// src/components/PaymentsEditor.jsx
import React from "react";

export default function PaymentsEditor({ payments, setPayments }) {
  const add = () =>
    setPayments((arr) => [
      ...arr,
      {
        date: new Date().toISOString(),
        amount: "",
        method: "cash",
        currency: "XOF",
        rate: 1,
        note: "",
      },
    ]);

  const update = (i, patch) =>
    setPayments((arr) => arr.map((p, idx) => (idx === i ? { ...p, ...patch } : p)));

  const remove = (i) => setPayments((arr) => arr.filter((_, idx) => idx !== i));

  const paidTotal = payments.reduce(
    (s, p) => s + Number(p.amount || 0) * Number(p.rate || 1),
    0
  );

  return (
    <div className="border rounded p-3">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h6 className="m-0">Paiements (partiels possibles)</h6>
        <button className="btn btn-sm btn-outline-primary" type="button" onClick={add}>
          + Ajouter
        </button>
      </div>

      {payments.map((p, i) => (
        <div className="row g-2 align-items-end mb-2" key={i}>
          <div className="col-6 col-md-2">
            <label className="form-label">Montant</label>
            <input
              className="form-control"
              value={p.amount}
              onChange={(e) => update(i, { amount: e.target.value })}
            />
          </div>

          <div className="col-6 col-md-2">
            <label className="form-label">Devise</label>
            <select
              className="form-select"
              value={p.currency}
              onChange={(e) => update(i, { currency: e.target.value })}
            >
              <option>XOF</option>
              <option>USD</option>
              <option>CNY</option>
              <option>EUR</option>
            </select>
          </div>

          <div className="col-6 col-md-2">
            <label className="form-label">Taux</label>
            <input
              className="form-control"
              value={p.rate}
              onChange={(e) => update(i, { rate: e.target.value })}
            />
          </div>

          <div className="col-6 col-md-3">
            <label className="form-label">Méthode</label>
            <select
              className="form-select"
              value={p.method}
              onChange={(e) => update(i, { method: e.target.value })}
            >
              <option value="cash">Cash</option>
              <option value="mobile_money">Mobile Money</option>
              <option value="bank">Virement</option>
              <option value="wechat">WeChat</option>
              <option value="alipay">Alipay</option>
            </select>
          </div>

          <div className="col-12 col-md-3">
            <label className="form-label">Note</label>
            <input
              className="form-control"
              value={p.note}
              onChange={(e) => update(i, { note: e.target.value })}
              placeholder="Réf, tranche 1, etc."
            />
          </div>

          <div className="col-12 col-md-2">
            <label className="form-label">Date</label>
            <input
              type="datetime-local"
              className="form-control"
              value={p.date?.slice(0, 16)}
              onChange={(e) => update(i, { date: new Date(e.target.value).toISOString() })}
            />
          </div>

          <div className="col-12 text-end">
            <button
              className="btn btn-sm btn-outline-danger"
              type="button"
              onClick={() => remove(i)}
            >
              Supprimer
            </button>
          </div>

          <div className="col-12">
            <hr className="my-2" />
          </div>
        </div>
      ))}

      <div className="mt-2">
        Total réglé (XOF): <strong>{paidTotal.toLocaleString("fr-FR")}</strong>
      </div>
    </div>
  );
}
